<div class="app">
  <app-outer-header></app-outer-header>
  <div class="app-outlet">
    <router-outlet></router-outlet>
  </div>
  <app-outer-footer></app-outer-footer>
</div>
